import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import QualityNexusLogo from "../QualityNexusLogo";

const HeroSection = () => {
  const { t, language } = useLanguage();

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-white to-gray-50 dark:from-nexus-dark dark:to-nexus-dark-light pt-24 pb-16 md:pt-32 md:pb-24">
      {/* Animated aurora background */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 -start-24 h-72 w-72 rounded-full bg-nexus-teal/20 blur-3xl animate-float-slow" />
        <div className="absolute top-1/3 -end-20 h-80 w-80 rounded-full bg-nexus-yellow/20 blur-3xl animate-float-slower" />
        <div className="absolute -bottom-24 start-1/3 h-72 w-72 rounded-full bg-nexus-red/15 blur-3xl animate-float-slow" />
      </div>

      <div className="container relative z-10">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto">
          <div className="mb-6 animate-rocket">
            <div className="relative">
              <span className="absolute inset-0 rounded-full bg-nexus-teal/30 blur-2xl animate-pulse-glow" />
              <QualityNexusLogo className="relative h-24 w-24 md:h-32 md:w-32 transition-transform duration-700 hover:rotate-12 hover:scale-110" />
            </div>
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-nexus-gray dark:text-white mb-6 animate-fade-in">
             {t("hero.title")}
          </h1>
          <p
            className="text-lg md:text-xl text-gray-600 dark:text-gray-300 max-w-2xl mb-8 animate-fade-in"
            style={{ animationDelay: "150ms", animationFillMode: "backwards" }}
          >
            {t("hero.subtitle")}
          </p>
          <div
            className="flex flex-col sm:flex-row gap-4 animate-fade-in"
            style={{ animationDelay: "300ms", animationFillMode: "backwards" }}
          >
            <Button asChild className="group bg-nexus-brand hover:bg-nexus-brand/90 text-white px-8 rounded-md text-lg shadow-lg shadow-nexus-brand/25 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-nexus-brand/40">
              <Link to="/services">
                {t("hero.exploreServices")}
                <ArrowRight className={`ms-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 rtl:group-hover:-translate-x-1 ${language === "ar" ? "rotate-180" : ""}`} />
              </Link>
            </Button>
            <Button asChild variant="outline" className="group border-2 border-nexus-gray text-nexus-gray dark:border-white dark:text-white hover:bg-nexus-gray/5 dark:hover:bg-white/5 px-8 rounded-md text-lg transition-all duration-300 hover:-translate-y-0.5">
              <Link to="/community">
                {t("hero.joinCommunity")}
                <ArrowRight className={`ms-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 rtl:group-hover:-translate-x-1 ${language === "ar" ? "rotate-180" : ""}`} />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="hidden md:block absolute top-20 start-10 w-16 h-16 rounded-full bg-nexus-teal/20 animate-float-slow"></div>
      <div className="hidden md:block absolute bottom-20 end-10 w-12 h-12 rounded-full bg-nexus-yellow/20 animate-float-slower"></div>
      <div className="hidden md:block absolute top-40 end-20 w-20 h-20 rounded-full bg-nexus-red/10 animate-float-slow"></div>
    </section>
  );
};

export default HeroSection;
